import { createFileRoute } from '@tanstack/react-router';

import Content from '@/routes/_authenticated/hilfe/datenschnittstellen.mdx';

export const Route = createFileRoute('/_authenticated/hilfe/datenschnittstellen')({
  component: Content,
});
